<template>
  <div>
    <list row-key="id" ref="list" unit="退货统计" :query-params="params" item-name="Itsms" :layout="layout"
      :center-title="centerTitle" :search-title="searchTitle" size="small" show-summary :summary-method="summaryMethod" :show-query="showQuery"
      :get-data-func="getDataFunc" @reset="reset">
      <template slot="toolbar-right">
        <slot name="toolbar-right">
        </slot>
        <el-button type="success" @click="toPrint">打印</el-button>
        <el-button type="primary" @click="onExport">导出</el-button>
      </template>
      <template slot="query">
        <el-form-item label="退货单号">
          <el-input v-model="deliveryNo" class="long_inp" placeholder="请选择" @focus="openDeliveryPick" readonly />
        </el-form-item>
        <el-form-item label="客户名称">
          <el-input v-model="FullName" class="long_inp" placeholder="请选择" @focus="openUnitPick" readonly />
        </el-form-item>
        <br>
        <el-form-item label="产品批号">
          <el-input v-model="BatchNumber" class="long_inp" placeholder="请选择" @focus="openBatchPick" readonly />
        </el-form-item>
        <el-form-item label="成品编码">
          <el-input v-model="ProductNo" class="long_inp" placeholder="请选择" @focus="openProductPick" readonly />
        </el-form-item>
        <br>
        <el-form-item label="商标编码">
          <el-input v-model="trademarkNo" class="long_inp" placeholder="请选择" @focus="openTrademarkPick" readonly />
        </el-form-item>
        <el-form-item label="颜色编码">
          <el-input v-model="Color" class="long_inp" placeholder="请选择" @focus="openColorPick" readonly />
        </el-form-item>
        <br>
        <el-form-item label="退货日期">
          <el-date-picker class="range-picker" v-model="OrderDateRange" type="daterange" range-separator="~"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="onChange" :clearable="false"
            style="width: 180px!important;margin-right: 219px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="查询分组方式">
          <el-radio-group v-model="params.StatType">
            <el-radio :label="0">按客户统计</el-radio>
            <el-radio :label="1">按单号统计</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="BatchNumber" label="产品批号" min-width="180px" />
        <el-table-column prop="Barcode" label="成品条码" min-width="120px" />
        <el-table-column prop="ColorName" label="颜色" />
        <!-- <el-table-column prop="TrademarkNo" label="商标" /> -->
        <el-table-column prop="UnitName" label="单位" />
        <el-table-column prop="Quantity" label="退货数量" />
        <!-- <el-table-column prop="" label="每件数" />
        <el-table-column prop="" label="退货件数" /> -->
        <el-table-column prop="Amount" label="退货金额" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <multi-pick-dialog ref="deliveryMultiPick" in-dialog @select-multiple="setDelivery" title="退货单列表"
      key-id="DeliveryDocId" key-name="退货单号" key-value="DeliveryDocNo" :func="deliveryApi.list"
      :default-value="deliveryNoArr" :params="{ DeliveryStatus: 1 }" />
    <multi-pick-dialog ref="unitMultiPick" in-dialog @select-multiple="setUnit" title="客户列表" key-id="TradeUnitId"
      key-name="客户名称" key-value="FullName" :func="unitApi.list":params="{TradeUnitTypes:[0,2]}" second-name="客户编号" second-value="TradeUnitNo"
      :default-value="unitArr" />
    <multi-pick-dialog ref="batchMultiPick" in-dialog @select-multiple="setBatch" title="产品批号列表" key-id="BatchId"
      key-name="产品批号" key-value="BatchNumber" :func="proApi.batchNumberList" :default-value="batchArr" />
    <multi-pick-dialog ref="productMultiPick" in-dialog @select-multiple="setProduct" title="成品编码列表" key-id="ProductId"
      key-name="成品编码" key-value="ProductNo" :func="proApi.list" second-name="成品名称" second-value="ProductName"
      :default-value="productArr" />
    <multi-pick-dialog ref="trademarkMultiPick" in-dialog @select-multiple="setTrademark" title="商标列表" key-id="TrademarkId" key-name="商标编码" key-value="TrademarkNo"
     :func="trademarkApi.list" second-name="商标名称" second-value="TrademarkName" :default-value="trademarkArr" :params="{ Status:1 }" />
    <multi-pick-dialog ref="colorMultiPick" in-dialog @select-multiple="setColor" title="颜色列表" key-id="ColorId"
      key-name="颜色名称" key-value="ColorName" :func="colorApi.list" second-name="颜色编码" second-value="ColorNo"
      :default-value="colorArr" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/multiList";
import multiPickDialog from '@/components/common/multiPickDialog';
export default {
  mixins: [listMixin],
  components: { list, multiPickDialog },
  //关于multiPickDialog，keyId唯一Id，keyName/Value主要字段名称/值，func列表接口，params接口参数传对象，secondName/Value第二列名称/值，select-multiple选择后的回调，defaultValue已选回显
  //关于multiList，isMerge：true时三层布局，false时二层布局，itemName第二层数组名称，itemName2第三层数组名称，layout表格上方信息布局
  data() {
    return {
      api: require("@/api/statistics/stoutdoc").default,
      deliveryApi: require('@/api/sa/deliveryDoc').default,
      unitApi: require('@/api/ba/tradeUnit').default,
      colorApi: require('@/api/ba/color').default,
      proApi: require('@/api/ba/product').default,
      trademarkApi: require('@/api/ba/trademark').default,
      params: {
        BusinessTypeNo: 4,
        DocIds: [],
        TradeUnitIds: [],
        BatchNumbers: [],
        ProductIds: [],
        TrademarkNos: [],
        ColorIds: [],
        StartDate: "",
        EndDate: "",
        StatType: 0,
      },
      OrderDateRange: [],
      //---
      deliveryNo: "",
      deliveryNoArr: [],
      //---
      FullName: "",
      unitArr: [],
      //---
      BatchNumber: "",
      batchArr: [],
      //---
      ProductNo: "",
      productArr: [],
      //---
      trademarkNo: "",
      trademarkArr: [],
      //---
      Color: "",
      colorArr: [],
      //---
      searchTitle: "",
      centerTitle: "",
      layout: [],
    };
  },
  beforeMount() {
    this.reset();
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this.api.getStOutStat(this.$commonJs.obj.removeNullKey(params)).then((res) => {
          if (params.StatType == 0) {
            this.centerTitle = "成品退货统计表（按客户合计）";
            this.searchTitle = "按客户统计";
            this.layout = [
              { name: "客户代码", key: "TradeUnitNo", span: 6 },
              { name: "客户名称", key: "TradeUnitName", span: 18 },
            ];
          } else {
            this.centerTitle = "成品退货统计表（按单号合计）";
            this.searchTitle = "按单号统计";
            this.layout = [
              { name: "退货单号", key: "DocNo", span: 6 },
              { name: "客户名称", key: "TradeUnitName", span: 18 },
            ];
          }
          // let Data = [];
          // Data = [
          //   { FullName: "张三", TradeUnitNo: "001", deliveryNo: "O001", Itsms: [{ BatchNo: "B001", ColorName: "红色", Quantity: 10 },{ BatchNo: "B002", ColorName: "绿色", Quantity: 20 }] },
          //   { FullName: "李四", TradeUnitNo: "002", deliveryNo: "O002", Itsms: [{ ColorName: "白色" }] },
          // ];
          // resolve({ Data });
          resolve(res);
        });
      });
    },
    openDeliveryPick() {
      this.$refs.deliveryMultiPick.open();
    },
    openWarehousePick() {
      this.$refs.warehouseMultiPick.open();
    },
    openUnitPick() {
      this.$refs.unitMultiPick.open();
    },
    openBatchPick() {
      this.$refs.batchMultiPick.open();
    },
    openProductPick() {
      this.$refs.productMultiPick.open();
    },
    openTrademarkPick() {
      this.$refs.trademarkMultiPick.open();
    },
    openColorPick() {
      this.$refs.colorMultiPick.open();
    },
    setDelivery(e, n, m) {
      this.deliveryNoArr = e;
      this.deliveryNo = n;
      this.params.DocIds = m;
    },
    setUnit(e, n, m) {
      this.unitArr = e;
      this.FullName = n;
      this.params.TradeUnitIds = m;
    },
    setBatch(e, n) {
      this.batchArr = e;
      this.BatchNumber = n;
      this.params.BatchNumbers = n ? n.split(",") : [];
    },
    setProduct(e, n, m) {
      this.productArr = e;
      this.ProductNo = n;
      this.params.ProductIds = m;
    },
    setTrademark(e,n) {
      this.trademarkArr = e;
      this.trademarkNo = n;
      this.params.TrademarkNos = n?n.split(","):[];
    },
    setColor(e, n, m) {
      this.colorArr = e;
      this.Color = (e.map(x => {return x.ColorNo})).join(",");
      this.params.ColorIds = m;
    },
    onChange(e) {
      this.params.StartDate = e ? e[0] : "";
      this.params.EndDate = e ? e[1] : "";
    },
    reset() {
      let today = this.$commonJs.getToday();
      this.OrderDateRange = [today.substr(0, 8) + "01", today];
      this.params.StartDate = today.substr(0, 8) + "01";
      this.params.EndDate = today;
      //----
      this.deliveryNo = "";
      this.deliveryNoArr = [];
      //----
      this.FullName = "";
      this.unitArr = [];
      //----
      this.BatchNumber = "";
      this.batchArr = [];
      //----
      this.ProductNo = "";
      this.productArr = [];
      //---
      this.trademarkNo = "";
      this.trademarkArr = [];
      //----
      this.Color = "";
      this.colorArr = [];
    },
    summaryMethod(params) {
      const { columns, data } = params;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          var params = this.$refs.list.tempQueryParams;
          sums[index] = params.StatType==0?"客户合计":"单号合计";
          return;
        } else if (index > 5) {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = Math.floor(sums[index]);
          } else {
            sums[index] = '-';
          }
        } else {
          sums[index] = "-"
        }
      });
      return sums;
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var params = this.$refs.list.tempQueryParams;
          var loading = this.$loading({
            lock: true,
            text: "正在导出...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.api.exportStOutStat(params).then(res => {
            loading.close();
          })
        })
        .catch(() => {});
      
    },
    toPrint() {
      let list = this.$refs.list;
      let path = "/returngoodsStatisticPrint?type=" + list.tempQueryParams.StatType;
      sessionStorage.setItem(path, JSON.stringify(list.data));
      let newpage = this.$router.resolve({ path });
      window.open(newpage.href, '_blank');
    },
  },
};
</script>
<style>
.long_inp .el-input__inner {
  width: 390px !important;
}
</style>